import { Pipe, PipeTransform } from '@angular/core';

const DISPUTE_STATUS_MAP = new Map<number, string>([
  [0, 'Not Disputed'],
  [1, 'Disputed']
]);

@Pipe({
  name: 'auditDisputeStatus',
  standalone: false
})
export class AuditDisputeStatusPipe implements PipeTransform {
  transform(value?: number | null): string {
    if (value == null) {
      return 'Ready for Review';
    }

    return DISPUTE_STATUS_MAP.get(value) ?? 'Unknown';
  }
}
